import React, { useState } from 'react';
import {
  Alert,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from '@mui/material';
import { useSnackbar } from 'notistack';
import axios from '../../utils/axios';

export default function AddBotDialog({ open, onClose, onSuccess }) {
  const [formData, setFormData] = useState({
    username: '',
    token: '',
    botType: 'personal',
  });
  const { enqueueSnackbar } = useSnackbar();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await axios.post('/telegram-bots', formData);
      enqueueSnackbar('Бот успешно добавлен', { variant: 'success' });
      setFormData({ username: '', token: '', botType: 'personal' });
      onSuccess();
    } catch (error) {
      enqueueSnackbar(
        error.response?.data?.message || 'Ошибка при добавлении бота',
        { variant: 'error' }
      );
    }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <form onSubmit={handleSubmit}>
        <DialogTitle>Добавить нового бота</DialogTitle>
        <DialogContent>
          <TextField
            autoFocus
            margin="dense"
            name="username"
            label="Имя пользователя бота"
            type="text"
            fullWidth
            value={formData.username}
            onChange={handleChange}
            required
            sx={{ mb: 2 }}
          />
          <TextField
            margin="dense"
            name="token"
            label="Токен бота"
            type="text"
            fullWidth
            value={formData.token}
            onChange={handleChange}
            required
            helperText="Получите токен у @BotFather в Telegram"
            sx={{ mb: 2 }}
          />
          <FormControl fullWidth margin="dense">
            <InputLabel id="add-bot-type-label">Тип бота</InputLabel>
            <Select
              labelId="add-bot-type-label"
              name="botType"
              value={formData.botType}
              onChange={handleChange}
              label="Тип бота"
            >
              <MenuItem value="public">Публичный</MenuItem>
              <MenuItem value="personal">Личный</MenuItem>
              <MenuItem value="private">Приватный</MenuItem>
            </Select>
          </FormControl>
          {formData.botType === 'private' && (
            <Alert severity="info" sx={{ mt: 2 }}>
              Новый приватный бот недоступен всем, пока список доступа пуст. После создания нажмите «Доступ» в списке ботов и добавьте @username, даже если пользователь ещё не заходил в систему.
            </Alert>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={onClose}>Отмена</Button>
          <Button type="submit" variant="contained">
            Добавить
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
}
